const __filename = "/app/views/pages/workroom.js", __dirname = "/app/views/pages";
const environmentHeadline = document.querySelector('[data-environment-headline]')

if (environmentHeadline) {
  const prefix = environmentHeadline.querySelector('[data-environment-prefix]')
  const acronym = environmentHeadline.querySelector('[data-environment-acronym]')
  const descriptor = environmentHeadline.querySelector('[data-environment-descriptor]')
  const changingParts = [prefix, acronym, descriptor]
  const environments = [
    { prefix: "It's your", acronym: 'IDE', descriptor: 'Integrated' },
    { prefix: 'your', acronym: 'ADE', descriptor: 'Agent' },
    { prefix: 'your', acronym: 'TDE', descriptor: 'Terminal' },
    { prefix: 'your', acronym: 'EDE', descriptor: 'Everything' },
  ]
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)')
  let environmentIndex = 0
  let isVisible = true
  let timer

  const setEnvironment = ({ prefix: nextPrefix, acronym: nextAcronym, descriptor: nextDescriptor }) => {
    prefix.textContent = nextPrefix
    acronym.textContent = nextAcronym
    descriptor.textContent = nextDescriptor
  }

  const animateParts = (keyframes, options) => Promise.all(
    changingParts.map((part) => part.animate(keyframes, options).finished),
  )

  const scheduleNextEnvironment = () => {
    window.clearTimeout(timer)
    if (reducedMotion.matches || document.hidden || !isVisible) return

    timer = window.setTimeout(async () => {
      await animateParts([
        { opacity: 1, filter: 'blur(0)', transform: 'translateY(0)' },
        { opacity: 0, filter: 'blur(7px)', transform: 'translateY(-0.14em)' },
      ], { duration: 160, easing: 'cubic-bezier(0.4, 0, 1, 1)', fill: 'forwards' })

      environmentIndex = (environmentIndex + 1) % environments.length
      setEnvironment(environments[environmentIndex])

      await animateParts([
        { opacity: 0, filter: 'blur(7px)', transform: 'translateY(0.14em)' },
        { opacity: 1, filter: 'blur(0)', transform: 'translateY(0)' },
      ], { duration: 320, easing: 'cubic-bezier(0.16, 1, 0.3, 1)', fill: 'forwards' })

      scheduleNextEnvironment()
    }, 2400)
  }

  const visibilityObserver = new IntersectionObserver(([entry]) => {
    isVisible = entry.isIntersecting
    scheduleNextEnvironment()
  })

  visibilityObserver.observe(environmentHeadline)
  document.addEventListener('visibilitychange', scheduleNextEnvironment)
  reducedMotion.addEventListener('change', scheduleNextEnvironment)
  scheduleNextEnvironment()
}

const proofVideo = document.querySelector('.proof-video')

if (proofVideo) {
  const reducedMotionVideo = window.matchMedia('(prefers-reduced-motion: reduce)')

  const syncVideoMotion = () => {
    if (reducedMotionVideo.matches) {
      proofVideo.removeAttribute('autoplay')
      proofVideo.pause()
      proofVideo.currentTime = 0
    } else {
      proofVideo.setAttribute('autoplay', '')
      proofVideo.play().catch(() => {})
    }
  }

  reducedMotionVideo.addEventListener('change', syncVideoMotion)
  syncVideoMotion()
}
